import CareerDetails from "./CareerDetails";

export default CareerDetails;
